(function() {
    'use strict';

    angular.module('mnp.modules', [ 'shopAuth', 'porting', 'portingstatus', 'reviseorder', 'mnp.filters', 'mnp.tracking']);
})();
